export const ADMIN_SHOW_PRODUCT = "admin/show/product";
export const ADMIN_PRODUCT_PAGE_INCREMANT = "admin/product/page/incremant" 
export const ADMIN_PRODUCT_PAGE_DECRIMANT = "admin/product/page/decrimant" 
export const ADMIN_DELETE_PRODUCT = "admin/product/delete"
export const Is_Loading = "admin/Is_Loading";